/* eslint-disable import/no-cycle */
import { IAppointment } from './appointments';
import { IUser } from './user';

export enum AssignmentStatus {
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
}

export interface IAssignment {
  id: string;
  status: AssignmentStatus;
  notary: IUser;
  appointment: IAppointment;
}
